import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import _WidgetBase from 'dijit/_WidgetBase';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import dojoStandby from 'dojox/widget/Standby';
import { group } from "dojo/regexp";
import { TranslationHelpers } from "../../more/Helpers";
import methodHooks from 'more/mdsMethodHooks';


interface StandbyGroup {
    groupname: string;
    steps: Array<{
        name: string,
        unnamed?: boolean,
        finished: boolean,
        label?: string,
        node?: HTMLElement,
        labelNode?: HTMLElement;
    }>;
    standbywidget: StandbyReg;
    _removeTimeout: any;
}
interface StandbyReg {
    stepsContainer: HTMLElement,
    dojoStandbyWidget: MdsLax<InstanceType<typeof dojoStandby>>,
    centerContainerNode: HTMLElement
    progressBarNode: HTMLElement;
    labelNode?: HTMLElement;
}
/**
 * StandbyManager verwaltet parallel laufende StandbyWidgets
 */
class StandbyManager extends methodHooks(compose(_WidgetBase)) {
    templateString = "<div></div>";

    private groupregistry: Array<StandbyGroup>;
    private activeCount: number = 0;
    private spinnerCount: number = 0;

    isActive(groupname?: string): boolean {
        if (!groupname) return this.activeCount > 0;

        let index = this.getIndexOfGroup(groupname);
        return index != -1;

        return false;
    }

    getRemainingSteps(groupname: string): Array<string> {
        let result = [];
        let index = this.getIndexOfGroup(groupname);
        if (index == -1) return null;

        for (let step of this.groupregistry[index].steps) {
            if (step.finished != true) {
                result.push(step.name);
            }
        }

        return result;
    }

    getRemainingStepCount(groupname: string): number {
        let result = this.getRemainingSteps(groupname);

        if (!result) return -1;

        if (result.length >= 0) return result.length;

        return -1;
    }

    createStandby(groupname: string, target: HTMLElement | MdsLax<InstanceType<typeof _WidgetBase>>, label?: string, initialSteps?: Array<string> | string) {

        if (!groupname) return;

        let index = this.getIndexOfGroup(groupname);
        if (index == -1) {
            let targetNode: HTMLElement = null;
            if ((target as MdsLax<InstanceType<typeof _WidgetBase>>).domNode) {
                targetNode = (target as MdsLax<InstanceType<typeof _WidgetBaseSP>>).domNode;
            } else if (target instanceof HTMLElement) {
                targetNode = target;
            } else return;

            let reg: StandbyGroup = {
                groupname: groupname ? groupname : "STB-" + (Math.random() * 1000000).toFixed(0).toString(),
                standbywidget: this._createStandbyWidget(targetNode),
                steps: [],
                _removeTimeout: null
            };

            this.groupregistry.push(reg);
            index = this.getIndexOfGroup(groupname);

            this.activeCount++;

            //this.addSpinner();
        }

        if (index == -1) return;

        let group = this.groupregistry[index];

        if (label) {
            label = TranslationHelpers.tryTranslate(label);
            group.standbywidget.labelNode = domConstruct.create("div", {
                "innerHTML": label,
                "className": "waitingText"
            }, group.standbywidget.progressBarNode, "only");
        } else if( label == "") {
            if (group.standbywidget.labelNode) {
                domConstruct.destroy(group.standbywidget.labelNode);
                group.standbywidget.labelNode = null;
            }
        }

        let steps: Array<string> = [];

        if (typeof (initialSteps) == "undefined") {
            steps.push("");
        } else {
            if (lang.isArray(initialSteps)) {
                steps = initialSteps;
            } else {
                steps = initialSteps.split(";");
            }
        }

        for (let step of steps) {
            this.addStep(step, null, null, group.groupname);
        }

        return group;
       
    }

    removeAllStandbys() {
        for (let group of this.groupregistry) {
            this.removeStandby(group);
        }
    }

    private _lastEndedTimeout: any = null;
    private removeStandby(group: StandbyGroup) {

       
        if (this._lastEndedTimeout) {
            clearTimeout(this._lastEndedTimeout)
            this._lastEndedTimeout = null;
        };
        if (group) {
           
            this.activeCount--;
            this.getRemainingSteps(group.groupname);
            
            
            let index = this.getIndexOfGroup(group.groupname);
            this.groupregistry.splice(index, 1);
            if (group.standbywidget?.dojoStandbyWidget) {
                domClass.add(group.standbywidget.dojoStandbyWidget.domNode, "stopping");
                setTimeout(lang.hitch(this, this._hideStandbyWidget, group.standbywidget.dojoStandbyWidget), 350);
            }
        }

        if (this.activeCount <= 0) {
            this._lastEndedTimeout = setTimeout(lang.hitch(this, this._onLastActiveEnd), 1000);
        }
    }
    private _hideStandbyWidget(widget: MdsLax<InstanceType<typeof dojoStandby>>) {
        widget.hide();
    }
    private getIndexOfStep(steppath: string, groupname?: string, finished?: boolean): number {
        let stepname = steppath;

        if (steppath) {
            let parts = steppath.split("/");
            

            if (parts.length == 2) {
                stepname = parts[0];

                if (!groupname) {
                    groupname = parts[1];
                }
            }
        }
        if (!groupname) return -1;

        let index = -1;

        let groupIndex = this.getIndexOfGroup(groupname);
        if (groupIndex == -1) return -1;

        let group = this.groupregistry[groupIndex];
        for (let step of group.steps) {
            index++;
            if (!steppath) {
                if (step.unnamed == true &&
                    (typeof (finished) == "undefined" || step.finished == finished)) {
                    return index;
                }
            } else {
                if (step.name == stepname &&
                    (typeof (finished) == "undefined" || step.finished == finished)) {
                    return index;
                }
            }
        }

        return -1;
    }
    private getIndexOfGroup(name: string): number {
        let i = -1;
        for (let reg of this.groupregistry) {
            i++;
            if (reg.groupname == name) return i;
        }
        return -1;
    }

    finishStep(steppath: string, groupname?: string) {

        //this._initSpinner();
        //console.debug("StandbyStep finished", groupname, steppath);

        let parts = []        
        let stepname = steppath;

        if (steppath) {
            parts = steppath.split("/");

            if (parts.length == 2) {
                stepname = parts[0];

                if (!groupname) {
                    groupname = parts[1];
                }
            }
        } 

        if (!groupname) return;
        let groupIndex = this.getIndexOfGroup(groupname);
        if (groupIndex == -1) return;
        let group = this.groupregistry[groupIndex];
      
        let stepindex = this.getIndexOfStep(stepname, groupname, false);
        if (stepindex == -1) return;

        this.removeSpinner();
        group.steps[stepindex].finished = true;


        this._delayedDrawStepsOnStandby(group);

        let unfinishedCount = 0;
        for (let step of group.steps) {
            if (step.finished != true) {
                unfinishedCount++;
                break;
            }
        }

        if (unfinishedCount == 0) {
            if (group._removeTimeout) clearTimeout(group._removeTimeout);
            group._removeTimeout = setTimeout(lang.hitch(this, this.removeStandby, group), group.steps.length > 1 ? 1000 : 10)            
        }
    }
    /**
     * Fügt einer Gruppe einen nötigen Schritt hinzu.
     * @param steppath Name des Schritts, kann auch als Pfad 'Gruppe/Schritt' angegeben sein
     * @param callback Optional: Callback, das nach Erledigung des Schritts ausgeführt werden soll
     * @param groupname Optional: Gruppenname, falls nicht im Steppath mitgegeben (übersteuert ggf. Gruppe aus Steppath)
     */
    addStep(steppath: string, callback?: Function, label?: string, groupname?: string) {
        let parts = steppath.split("/");
        let stepname = steppath;


        if (parts.length == 2) {
            stepname = parts[0];

            if (!groupname) {
                groupname = parts[1];
            }
        }

        if (!groupname) return;
        let stepindex = this.getIndexOfStep(stepname, groupname);

        let groupIndex = this.getIndexOfGroup(groupname);
        if (groupIndex == -1) return;
        let group = this.groupregistry[groupIndex];

        if (group._removeTimeout) {
            clearTimeout(group._removeTimeout);
            group._removeTimeout = null;
        }

        if (this._lastEndedTimeout) {
            clearTimeout(this._lastEndedTimeout)
            this._lastEndedTimeout = null;
        };

        if (!steppath) {
            // kein Name mitgegeben, dann wird ein generischer unnamed step erzeugt
            group.steps.push({
                name: "_unnamed",
                finished: false,
                unnamed: true,
                node: null
            });
            this.addSpinner();

        }
        else if (stepindex == -1) {
            group.steps.push({
                name: stepname,
                finished: false,
                unnamed: false,
                node: null
            });
            this.addSpinner();

        } else {
            label = TranslationHelpers.tryTranslate(label);

            group.steps[stepindex].finished = false;
            group.steps[stepindex].label = label;

            this.addSpinner();
        }

        //console.debug("StandbyStep added", group.groupname, stepname, group);

        this._delayedDrawStepsOnStandby(group);
    }

    private _groupDrawHandles: Array<{
        groupname: string,
        timeoutHandle: any;
    }>;
    private _delayedDrawStepsOnStandby(group: StandbyGroup) {

        let handleIndex = -1;
        for (let handleReg of this._groupDrawHandles) {
            handleIndex++;
            if (handleReg.groupname == group.groupname) {
                clearTimeout(handleReg.timeoutHandle);

                this._groupDrawHandles.splice(handleIndex, 1);
                break;
            }
        }

        this._groupDrawHandles.push({
            groupname: group.groupname,
            timeoutHandle: setTimeout(lang.hitch(this, this.drawStepsOnStandby, group), 80)
        });
    }
    private drawStepsOnStandby(group: StandbyGroup) {
        if (!group.standbywidget) return;
        let std = group.standbywidget.dojoStandbyWidget;
        let containerNode = group.standbywidget.centerContainerNode;
        let stepsRoot = group.standbywidget.stepsContainer;

        if (!containerNode) {
            // da stimmt was nicht am Aufbau vom StandbyWidget
            return;
        }

        if (!stepsRoot) {
            stepsRoot = domConstruct.create("div", {
                className: "stepsContainer w3-hide"
            }, containerNode);

            group.standbywidget.stepsContainer = stepsRoot;
        }

        domClass.toggle(stepsRoot, "w3-hide", group.steps.length <= 1);
        
        if (group.steps.length > 1) {
            for (let step of group.steps) {
                let stepContainer = step.node;

                if (!stepContainer) {

                    stepContainer = domConstruct.create("div", {
                        className: "progressStep"
                    }, stepsRoot);

                    domConstruct.create("div", {
                        className: "progressStepIndicator"
                    }, stepContainer);

                    step.node = stepContainer;
                }

                // Achtung: wenn sich Label ändert....
                let labelNode = step.labelNode;
                if (!labelNode) {
                    labelNode = domConstruct.create("label", {
                        className: "progressStepLabel",
                        innerHTML: "X",
                    }, stepContainer);

                    step.labelNode = labelNode;
                }
                if (step.label) {
                    domAttr.set(labelNode, "innerHTML", step.label);
                }

                if (step.labelNode) domClass.toggle(step.labelNode, "w3-hide", !step.label);
                domClass.toggle(stepContainer, "finished", step.finished == true);

            }
        }

    }
    private _createStandbyWidget(targetNode): StandbyReg {
        if (!targetNode) return null;
        let std = new dojoStandby({
            target: targetNode,
            //color: "#ff0000",
            /*image: require.toUrl("more/loadingbars-40px.svg").toString()*/
        });

        std.domNode.className = "dojoStandby starting";

        let pContainer = domConstruct.create("div",
            {
                "className": "progressContainer",
                "id": "progressContainer"
            },
            std.domNode.firstChild);

        let pBar = domConstruct.create("div",
            { "className": "loadingBar ego_animated_progressBar" },
            pContainer);

        pBar.style.setProperty("--durationModifier", (Math.random() - 1).toFixed(1) + "s");

        std["progressBarNode"] = pBar;

        document.body.appendChild(std.domNode);

        std.target = targetNode;


        domClass.add(std.domNode, "starting");
        domClass.remove(std.domNode, "stopping");

        std.show();

        setTimeout(lang.hitch(this, domClass.remove, std.domNode, "starting"), 10);

        (this.emit as any)("StandbyStart");

        return {
            centerContainerNode: pContainer,
            stepsContainer: null,
            dojoStandbyWidget: std,
            progressBarNode: pBar
        };
    }

    private _hideSpinner() {
        if (this.spinnerCount > 0) return;

        let spinnerContainer = document.getElementById("globalSpinnerContainer");
        let spinnerElem = document.getElementById("globalSpinner");

        if (spinnerElem) {
            this._removeSpinAnimationTimeout = setTimeout(
                lang.hitch(this,
                    function (spinnerElem) {
                        domClass.remove(spinnerElem, "fa-spin show hidden");
                        domClass.remove(document.body, "_backgroundActivity");
                    },
                    spinnerElem),
                10000);
        }

        if (spinnerContainer) {
            domClass.add(spinnerContainer, "fadeOpacity");
            //domClass.add(spinnerElem, "hidden");
            setTimeout(lang.hitch(this, function (spinnerElem) { domClass.add(spinnerElem, "hidden"); }, spinnerContainer), 10);
            setTimeout(lang.hitch(this, function () { domClass.remove(document.body, "_backgroundActivity"); }), 10);
            //setTimeout(lang.hitch(this, function (spinnerElem) { domClass.add(spinnerElem, "w3-hide"); }, spinnerElem), 1000);
        }

        this._hideSpinnerTimeout = null;
    }
    private _removeSpinAnimationTimeout: any = null;
    private _initSpinner(maxDurationSec?: number) {
        if (this._hideSpinnerTimeout) clearTimeout(this._hideSpinnerTimeout);

        let spinnerContainer = document.getElementById("globalSpinnerContainer");
        let spinnerElem = document.getElementById("globalSpinner");
        if (spinnerContainer) {
            if (this.spinnerCount == 1) {
                domClass.add(spinnerContainer, "hidden");
            }
            domClass.add(spinnerContainer, "fadeOpacity show");
            domClass.add(document.body, "_backgroundActivity");
            setTimeout(lang.hitch(this, function (spinnerElem) { domClass.remove(spinnerElem, "w3-hide"); }, spinnerContainer), 10);
            setTimeout(lang.hitch(this, function (spinnerElem) { domClass.remove(spinnerElem, "hidden"); }, spinnerContainer), 20);   
        }

        if (spinnerElem) {
            if (this._removeSpinAnimationTimeout) {
                clearTimeout(this._removeSpinAnimationTimeout);
                this._removeSpinAnimationTimeout = null;
            }
            domClass.add(spinnerElem, "fa-spin");
        }

        this._showSpinnerTimeout = null;

        if (!maxDurationSec) maxDurationSec = 45;

        this._hideSpinnerTimeout = setTimeout(lang.hitch(this, this._hideSpinner), maxDurationSec * 1000);
    }

    private _hideSpinnerTimeout: any = null;
    private _showSpinnerTimeout: any = null;

    private _onLastActiveEnd() {
        if (this.activeCount < 0) this.activeCount = 0;
        if (this.activeCount > 0) return;
        if (this._hideSpinnerTimeout) clearTimeout(this._hideSpinnerTimeout);

        //console.debug("last Standby End");

        this._hideSpinnerTimeout = setTimeout(lang.hitch(this, this.removeSpinner, true), 100);
    }

    addSpinner() {
        this.spinnerCount++;

        //console.debug("add spinner, count: " + this.spinnerCount);

        this._initSpinner();
    }

    removeSpinner(reset?: boolean) {
        this.spinnerCount--;

        if (reset === true) {
            this.spinnerCount = 0;
        }
        //console.debug("remove spinner, count: " + this.spinnerCount);

        if (this.spinnerCount < 0) {
            this.spinnerCount = 0;
            return;
        }

        
        if (this.spinnerCount == 0) {
            this._hideSpinner();
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);        

        this.groupregistry = [];
        this._groupDrawHandles = [];
    }

    destroy() {
        super.destroy.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(StandbyManager);